import { createFileRoute } from "@tanstack/react-router";

import AccountDetail from "@/components/[routes]/accounts/accounts-detail";

export const Route = createFileRoute("/_secure/accounts/$id")({
  component: AccountDetail,
});
